import gql from 'graphql-tag';

export default gql`
  mutation advanceAllocationOnConfirm($allocationId: ID!) {
    allocation: advanceAllocationOnConfirm(allocationId: $allocationId) {
      id
    }
  }
`;
